<template>
  <div>
    <b-dropdown v-if="Object.keys(localValue).length > 0" ref="dropdown"
                :text="label + ' (' + Object.keys(localValue).length + ')'" class="ml-2" :split="!disabled"
                split-variant="primary" variant="primary" @click="openAttachment">
      <b-dropdown-text class="text-nowrap" style="width: max-content">
        <div v-for="(file, fileIndex) in localValue" :key="file.id"
             :class="{'border-bottom': Object.keys(localValue).length !== fileIndex + 1}" class="row">
          <div class="col">
            <b-dropdown-item href="javascript:void(0);" @click.prevent="downloadFile(file)">
              {{ file.file.substr(11) }}
            </b-dropdown-item>
          </div>
          <div class="col text-right">
            <b-dropdown-item-button @click.prevent="localValue.splice(fileIndex, 1)" v-if="!disabled">
              <fa icon="times"/>
            </b-dropdown-item-button>
          </div>
        </div>
      </b-dropdown-text>
    </b-dropdown>
    <b-button v-else ref="dropdown" class="ml-2" type="button" variant="primary" @click="openAttachment">
      {{ label }}
    </b-button>
    <b-modal id="modal-attachment" ref="attachmentModal" :ok-title="$t('core.save')" :title="$t('core.attachments')" size="lg"
             @ok="save">
      <o-dropzone v-model="localValue" :deleteUrl="deleteUrl" :save-url="saveUrl" :type="type"
                  @attachments="addAttachment">
      </o-dropzone>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'o-attachment',
  props: {
    value: {
      default: null
    },
    label: {
      type: String
    },
    saveUrl: {
      type: String
    },
    deleteUrl: {
      type: String
    },
    downloadUrl: {
      type: String
    },
    type: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localValue: '',
    files: []
  }),

  mounted () {
    this.localValue = this.value
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.localValue = newVal
      }
    },
    localValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    openAttachment () {
      if (this.disabled) {
        return
      }
      this.$refs.attachmentModal.show()
    },
    closeAttachment () {
      this.$refs.attachmentModal.hide()
    },
    save () {
      this.$emit('action', this.files)
      this.closeAttachment()
    },
    addAttachment (file) {
      const _self = this
      if (file.action === 'delete_all') {
        _self.files = []
      }

      if (file.action === 'delete') {
        let key = -1
        _self.files.forEach(function (deletedFile, i) {
          if (deletedFile.servername === file.servername) {
            key = i
          }
        })
        _self.files.splice(key, 1)
      }

      if (file.action === 'upload' && file.status === 'SUCCESS') {
        _self.files.push({
          file: file.file,
          servername: file.servername,
          action: file.action,
          status: file.status
        })
      }
    },
    downloadFile (file) {
      axios.get(this.downloadUrl + '' + file.id + '/' + this.type, { responseType: 'arraybuffer' })
        .then((response) => {
          this.forceFileDownload(response, file.file.substr(11))
        }).catch((error) => {
          if (error.response.status === 404) {
            this.$notify({
              title: this.$i18n.t('core.error'),
              text: this.$i18n.t('sandoz.file_not_found'),
              type: 'error'
            })
          } else {
            this.$notify({
              title: this.$i18n.t('core.error_alert_title'),
              text: this.$i18n.t('core.error_alert_text'),
              type: 'error'
            })
          }
        })
    },
    forceFileDownload (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
